// src/firebase/firestoreService.js

import {
  collection, addDoc, getDocs, doc,
  updateDoc, deleteDoc, query, where,
  serverTimestamp
} from 'firebase/firestore';

import { signInWithEmailAndPassword, signOut } from 'firebase/auth';
import { db, auth } from './firebaseConfig';

/* 🔥 CLOUDINARY CONFIG */
const CLOUD_NAME = "dvc0m3iln";

const PRESETS = {
  toppers: "toppers",
  faculty: "faculty"
};

const uploadImage = async (file, type) => {
  if (!file) return '';

  try {
    const data = new FormData();
    data.append("file", file);
    data.append("upload_preset", PRESETS[type]);

    const res = await fetch(
      `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`,
      {
        method: "POST",
        body: data
      }
    );

    const result = await res.json();

    console.log("UPLOAD RESULT:", result); // 🔥 debug

    if (result.error) {
      console.error("Cloudinary error:", result.error.message);
      return '';
    }

    return result.secure_url;

  } catch (err) {
    console.error("Upload crash:", err);
    return '';
  }
};
/* ───────── COLLECTIONS ───────── */
const C = {
  ENQUIRIES: 'enquiries',
  FACULTY: 'faculty',
  TOPPERS: 'toppers',
  TESTIMONIES: 'testimonies',
};

/* ───────── AUTH ───────── */
export const adminLogin = async (email, password) => {
  const cred = await signInWithEmailAndPassword(auth, email, password);
  return cred.user;
};

export const adminLogout = () => signOut(auth);

/* ───────── ENQUIRIES ───────── */
export const submitEnquiry = async (data) =>
  addDoc(collection(db, C.ENQUIRIES), {
    ...data,
    status: 'pending',
    createdAt: serverTimestamp(),
  });

export const getAllEnquiries = async () => {
  const snap = await getDocs(collection(db, C.ENQUIRIES));
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
};

export const deleteEnquiry = async (id) =>
  deleteDoc(doc(db, C.ENQUIRIES, id));

/* ───────── FACULTY ───────── */
export const getAllFaculty = async () => {
  const snap = await getDocs(collection(db, C.FACULTY));
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
};

export const addFaculty = async ({ name, subject, qualification, experience, imageFile }) => {
  const imageURL = await uploadImage(imageFile, "faculty");

  const docRef = await addDoc(collection(db, C.FACULTY), {
    name,
    subject,
    qualification,
    experience,
    imageURL,
    createdAt: serverTimestamp(),
  });

  return { id: docRef.id, imageURL };
};

export const deleteFaculty = async (id) =>
  deleteDoc(doc(db, C.FACULTY, id));

/* ───────── TOPPERS ───────── */
export const getAllToppers = async () => {
  const snap = await getDocs(collection(db, C.TOPPERS));
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
};

export const addTopper = async ({ name, year, percentage, course, imageFile }) => {
  const imageURL = await uploadImage(imageFile, "toppers");

  const docRef = await addDoc(collection(db, C.TOPPERS), {
    name,
    year,
    percentage,
    course,
    imageURL,
    createdAt: serverTimestamp(),
  });

  return { id: docRef.id, imageURL };
};

export const deleteTopper = async (id) =>
  deleteDoc(doc(db, C.TOPPERS, id));

/* ───────── TESTIMONIES ───────── */
export const getApprovedTestimonies = async () => {
  const snap = await getDocs(
    query(collection(db, C.TESTIMONIES), where('approved', '==', true))
  );
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
};

export const submitTestimony = async (data) =>
  addDoc(collection(db, C.TESTIMONIES), {
    ...data,
    approved: false,
    createdAt: serverTimestamp(),
  });

export const getPendingTestimonies = async () => {
  const snap = await getDocs(
    query(collection(db, C.TESTIMONIES), where('approved', '==', false))
  );
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
};

export const approveTestimony = async (id) =>
  updateDoc(doc(db, C.TESTIMONIES, id), { approved: true });

export const deleteTestimony = async (id) =>
  deleteDoc(doc(db, C.TESTIMONIES, id));

export { C as COLLECTIONS };